<!--
 * @description: Don't description
 * @Author: Mustafa.Yin
 * @Date: 2023-09-25 15:06:07
 * @FilePath: \smart-reco-xnd:\vue_project\smart-reco-h5\src\App.vue
 * @LastEditTime: 2025-08-24 16:29:25
-->
<template>
  <router-view/>
</template>
<script>
// 假设是 H5 页面入口 JS，比如 main.js / App.js / index.html 中的脚本

import { initUserSessionId } from '@/utils/sessionManager';



export default {
  created() {
    // 页面加载时初始化（一般放在入口文件或根组件 componentDidMount / useEffect）
    initUserSessionId();
    // 禁止页面缩放
    window.onload = function () {
      document.addEventListener("touchstart", function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener("gesturestart", function (event) {
        event.preventDefault();
      });
    };
  },
}
</script>
<style>
body{
}
</style>
